import { applyUTMParamsForLoginButtons } from "@utils/UTMParamUtils";
import identifyQualifiedTraffic from "@utils/identifyQualifiedTraffic";
import { handleCustomUDL } from "@utils/UDLUtils";

export class ButtonGroup {
  private el: HTMLElement;
  private abortController: AbortController;

  constructor(el: HTMLElement) {
    this.el = el;
    this.abortController = new AbortController();
  }

  init(): void {
    const signal = this.abortController.signal;

    this.el
      .querySelectorAll<HTMLAnchorElement>(
        '.comp-button[data-event-tracking="true"] a.button',
      )
      .forEach((anchor) => {
        anchor.addEventListener(
          "click",
          (e) => {
            const linkElement = e.currentTarget as HTMLAnchorElement;
            const buttonGroupParams = this.getCommonParameters(linkElement);
            const customParams = { ...linkElement.dataset };
            Object.assign(buttonGroupParams, customParams);
            this.pushData(buttonGroupParams);
          },
          { signal },
        );
      });

    applyUTMParamsForLoginButtons(this.el);
  }

  private getCommonParameters(
    linkElement: HTMLAnchorElement,
  ): Record<string, string | boolean> {
    const isInternal = linkElement.host === window.location.host;
    const link_url = linkElement.href;
    return {
      link_text: linkElement.innerText,
      link_url,
      platform: "website",
      link_type: isInternal ? "internal" : "external",
      protocol: isInternal
        ? window.location.protocol
        : new URL(linkElement.href).protocol,
      ...identifyQualifiedTraffic(link_url),
    };
  }

  private pushData(buttonGroupParams: Record<string, unknown>): void {
    handleCustomUDL("button_group", buttonGroupParams);
  }

  destroy(): void {
    this.abortController.abort();
  }

  static initAll(root: Document | HTMLElement = document): void {
    root
      .querySelectorAll<HTMLElement>('[data-component="buttongroup"]')
      .forEach((el) => {
        new ButtonGroup(el).init();
      });
  }
}
